import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[credit-card]' // Attribute selector
})
export class CreditCardDirective {

  @HostListener('input', ['$event'])
  confirmFirst(event: any) {
    let val = event.target.value;
    event.target.value = this.setElement(val);
  }

  constructor(public element: ElementRef) { }

  setElement(val) {
    let num = '';
    var v = val.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
    var matches = v.match(/\d{4,16}/g);
    var match = matches && matches[0] || '';
    var parts = [];
    for (var i = 0, len = match.length; i < len; i += 4) {
      parts.push(match.substring(i, i + 4));
    }
    if (parts.length) {
      num = parts.join(' ').trim();
    } else {
      num = val.trim();
    }
    return num;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/directives/credit-card.directive.ts